import { ReportGridColDef } from "./subComponents/reportTable";

export const columnsConfig: {
    // inventory coloumns 
    dailySalesReport: ReportGridColDef[],
    stockReportColumns: ReportGridColDef[],
    itemWiseColumns: ReportGridColDef[],
    lowStockColumns: ReportGridColDef[],
    stockMovemntColumns: ReportGridColDef[],
    ValuationColumns: ReportGridColDef[],

    // cheque reports
    pendingChequeColumns: ReportGridColDef[],
    clearedChequeColumns: ReportGridColDef[],
    bouncedChequeColumns: ReportGridColDef[],
    monthlyChequeColumns: ReportGridColDef[],
} = {
    // inventory reports 
    dailySalesReport: [
        {
            field: "date",
            headerName: "Date",
            flex: 1,
            type: "date",
            valueGetter: (value) => value ? new Date(value) : null
        },

        { field: "totalBills", headerName: "Total Bills", flex: 1, type: "number" },

        {
            field: "totalSales",
            headerName: "Total Sales",
            flex: 1,
            type: "number",
            reportType: "currency"
        },

        { field: "cash", headerName: "CASH", flex: 1, type: "number", reportType: "currency" },
        { field: "upi", headerName: "UPI", flex: 1, type: "number", reportType: "currency" },
        { field: "card", headerName: "CARD", flex: 1, type: "number", reportType: "currency" },
        { field: "bank", headerName: "BANK", flex: 1, type: "number", reportType: "currency" },
    ],

    stockReportColumns: [
        {
            field: "ItemName",
            headerName: "Item Name",
            flex: 1,
            valueGetter: (value, row) => row?.item?.ItemName || "-"
        },

        {
            field: "WarehouseName",
            headerName: "Warehouse",
            flex: 1,
            valueGetter: (value, row) => row?.warehouse?.WarehouseName || "-"
        },

        {
            field: "CurrentStock",
            headerName: "Current Stock",
            flex: 1,
            type: "number"
        },

        {
            field: "ReorderLevel",
            headerName: "Reorder Level",
            flex: 1,
            type: "number"
        }
    ],

    itemWiseColumns: [
        {
            field: "itemName",
            headerName: "Item Name",
            flex: 1,
            valueGetter: (value, row) => row?.item?.ItemName || "-"
        },

        {
            field: "TotalStock",
            headerName: "Total Stock",
            flex: 1,
            type: "number"
        },

        {
            field: "ReorderLevel",
            headerName: "Reorder Level",
            flex: 1,
            type: "number"
        },

        {
            field: "status",
            headerName: "Stock Status",
            flex: 1,
            valueGetter: (value, row) => {
                const stock = row?.TotalStock ?? 0;
                const reorder = row?.ReorderLevel ?? 0;

                return stock <= reorder ? "Low Stock" : "In Stock";
            }
        }
    ],

    lowStockColumns: [
        {
            field: "itemName",
            headerName: "Item Name",
            flex: 1,
            valueGetter: (value, row) => row?.item?.ItemName || "-"
        },

        {
            field: "warehouseName",
            headerName: "Ware House",
            flex: 1,
            valueGetter: (value, row) => {
                return row?.warehouse?.WarehouseName || "-";
            }
        },

        {
            field: "CurrentStock",
            headerName: "Current Stock",
            flex: 1,
            type: "number"
        },

        {
            field: "ReorderLevel",
            headerName: "Reorder Level",
            flex: 1,
            type: "number"
        },
    ],

    stockMovemntColumns: [
        {
            field: "ItemName",
            headerName: "Item Name",
            flex: 1,
            valueGetter: (value, row) => row?.item?.ItemName || "-"
        },

        {
            field: "WarehouseName",
            headerName: "Warehouse",
            flex: 1,
            valueGetter: (value, row) => row?.warehouse?.WarehouseName || "-"
        },

        {
            field: "Quantity",
            headerName: "Quantity",
            flex: 1,
            type: "number"
        },

        {
            field: "TransactionType",
            headerName: "Transaction Type",
            flex: 1,
        },

        {
            field: "date",
            headerName: "Date",
            flex: 1,
            type: "date",
            valueGetter: (value) => value ? new Date(value) : null
        },
    ],

    ValuationColumns: [
        {
            field: "itemName",
            headerName: "Item Name",
            flex: 1,
            valueGetter: (value, row) => row?.item?.ItemName || "-"
        },
        {
            field: "warehouseName",
            headerName: "Ware House",
            flex: 1,
            valueGetter: (value, row) => {
                return row?.warehouse?.WarehouseName || "-";
            }
        },

        {
            field: "Quantity",
            headerName: "Quantity",
            flex: 1,
            type: "number"
        },

        {
            field: "StockValue",
            headerName: "Stock Value",
            flex: 1,
            type: "number"
        },

        {
            field: "PurchasePrice",
            headerName: "Purchase Price",
            flex: 1,
            type: "number",
            reportType: "currency"
        },
    ],

    // cheque reports 
    pendingChequeColumns: [
        {
            field: "ChequeNumber",
            headerName: "Cheque No",
            flex: 1
        },

        {
            field: "PartyName",
            headerName: "Party Name",
            flex: 1
        },

        {
            field: "PartyType",
            headerName: "Type",
            flex: 1
        },

        {
            field: "BankName",
            headerName: "Bank",
            flex: 1
        },

        {
            field: "ChequeType",
            headerName: "Cheque Type",
            flex: 1
        },

        {
            field: "Amount",
            headerName: "Amount",
            flex: 1,
            type: "number",
            reportType: "currency"
        },

        {
            field: "ChequeDate",
            headerName: "Cheque Date",
            flex: 1,
            type: "date",
            valueGetter: (value) => value ? new Date(value) : null
        },

        {
            field: "DueDate",
            headerName: "Due Date",
            flex: 1,
            type: "date",
            valueGetter: (value) => value ? new Date(value) : null
        },
    ],

    clearedChequeColumns: [
        {
            field: "ChequeNumber",
            headerName: "Cheque No",
            flex: 1
        },

        {
            field: "PartyName",
            headerName: "Party Name",
            flex: 1
        },

        {
            field: "PartyType",
            headerName: "Type",
            flex: 1
        },

        {
            field: "BankName",
            headerName: "Bank",
            flex: 1
        },

        {
            field: "ChequeType",
            headerName: "Cheque Type",
            flex: 1
        },

        {
            field: "Amount",
            headerName: "Amount",
            flex: 1,
            type: "number",
            reportType: "currency"
        },

        {
            field: "ChequeDate",
            headerName: "Cheque Date",
            flex: 1,
            type: "date",
            valueGetter: (value) => value ? new Date(value) : null
        },

        {
            field: "DueDate",
            headerName: "Due Date",
            flex: 1,
            type: "date",
            valueGetter: (value) => value ? new Date(value) : null
        },
    ],

    bouncedChequeColumns: [
        {
            field: "ChequeNumber",
            headerName: "Cheque No",
            flex: 1
        },

        {
            field: "PartyName",
            headerName: "Party Name",
            flex: 1
        },

        {
            field: "PartyType",
            headerName: "Type",
            flex: 1
        },

        {
            field: "BankName",
            headerName: "Bank",
            flex: 1
        },

        {
            field: "ChequeType",
            headerName: "Cheque Type",
            flex: 1
        },

        {
            field: "Amount",
            headerName: "Amount",
            flex: 1,
            type: "number",
            reportType: "currency"
        },

        {
            field: "ChequeDate",
            headerName: "Cheque Date",
            flex: 1,
            type: "date",
            valueGetter: (value) => value ? new Date(value) : null
        },

        {
            field: "DueDate",
            headerName: "Due Date",
            flex: 1,
            type: "date",
            valueGetter: (value) => value ? new Date(value) : null
        },
    ],

    monthlyChequeColumns: [
        {
            field: "month",
            headerName: "Month",
            flex: 1,
            type: "number"
        },

        {
            field: "totalCheques",
            headerName: "Total Cheques",
            flex: 1,
            type: "number"
        },

        {
            field: "totalAmount",
            headerName: "Total Amount",
            flex: 1,
            type: "number",
            reportType: "currency"
        },
    ]
};